<template>
  <v-alert
    class="error-dialog"
    :value="errorDialog"
    type="error"
    color="error"
    icon="warning"
    transition="scale-transition"
    outline
  >
    <v-layout align-center>
      <span class="error--text">{{ errorMessage }}</span>
      <v-spacer />
      <v-btn flat icon color="error" @click="errorDialog = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
  </v-alert>
</template>

<script>
export default {
  computed: {
    errorDialog: {
      get() {
        return this.$store.getters.errorDialog;
      },
      set(val) {
        if (!val) this.$store.dispatch('closeErrorDialog');
      },
    },
    errorMessage: {
      get() {
        return this.$store.getters.errorMessage;
      },
    },
  },
};
</script>

<style>
.error-dialog {
  background-color: white;
  z-index: 1000;
}
</style>
